export default class Collapsable {

  constructor() {
    this.init();
  }

  init() {
    Array.from(document.getElementsByClassName('click-region')).forEach((el) => {
      const section = el.closest('.collapsable');
      el.addEventListener('click', () => {
        if (section.classList.contains('open')) {
          section.classList.remove('open');
          el.setAttribute("aria-expanded", false);
        } else {
          section.classList.add('open');
          el.setAttribute("aria-expanded", true);
        }
      });
    });

    Array.from(document.getElementsByClassName('expand-all')).forEach((el) => {
      el.addEventListener('click', () => {
        let siblings = [];
        let sibling = el.parentNode.nextElementSibling;

        while(sibling && sibling.classList.contains('collapsable')) {
          siblings.push(sibling);
          sibling = sibling.nextElementSibling;
        }

        siblings.forEach((collapsable) => {
          collapsable.classList.add('open');
          collapsable.querySelector('.click-region').setAttribute("aria-expanded", true);
        });
      });
    });
  }
}
